export interface IUserJobFilterState {
	possibleResults: number;
}

export const defaultState = (): IUserJobFilterState => ({
	possibleResults: 0
});

export default defaultState;
